module.exports = __webpack_public_path__ + "static/media/ppe_saf_ove.e88cd36c.png";